import { css } from 'styled-components';
import { media } from '..';
/**
 * Hover focus only shows hover and focus stylse on devices bigger
 * than tablet. This is to prevent sticky hovers on touch devices.
 */
export const hoverFocus = (first, ...interpolations) => media.up('lg') `
  &:hover,
  &:focus {
    ${css(first, ...interpolations)}
  }
`;
//# sourceMappingURL=hover-focus.js.map